import {match} from 'ts-pattern';

/**
 * Opaque background of a sticky row part (selection checkbox, pinned cell, action column).
 * Rows scroll beneath sticky parts, so they mirror the row state explicitly, with the matching
 * hover shade. Selection wins over the row highlight.
 */
export const getStickyCellBackgroundClass = (isSelected: boolean, isHighlighted: boolean) =>
  match({isSelected, isHighlighted})
    .with({isSelected: true}, () => 'bg-blue-200 group-hover/row:bg-blue-300')
    .with({isHighlighted: true}, () => 'bg-palettes-red-20-100 group-hover/row:bg-blue-100')
    .otherwise(() => 'bg-white group-hover/row:bg-blue-100');
